import { LockerRack } from '../microservices';
import { getBaseUrl } from '../../maps/apiEnvironmentMap';

const API_KEY = process.env.REACT_APP_API_KEY;

export class LockerContentRequestGET {
  readonly method: string = 'operation/content/locker-rack';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
      },
    };
  }
}
export type LockerContentResponseGET = {
  status: string;
  message: string;
  data: {
    lockerRack: LockerRack;
    message: string;
    errors: any;
  };
};
